var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/tabber_mykit_selected.d66261d5.png","uri@2x": __webpack_public_path__ + "static/media/tabber_mykit_selected.7c30e6f4.png","uri@3x": __webpack_public_path__ + "static/media/tabber_mykit_selected.12d47c75.png",
    width: 27,
    height: 27
});